import {
    maxLength,
    required,
    createValidator,
    createCollector,
} from '../../../../../../../common/utils/validatorService.js'

const VALIDATE_RULES = {
    header: [required(), maxLength(100)],
}
export const timeIsUpValidator = createValidator(VALIDATE_RULES)
export const collectTimeIsUpErrors = createCollector(VALIDATE_RULES)
